window.dt_pabean_report_goods_receipts = (elm) => {
  const $table = $(elm).closest('div').find('table');
  const uid = $(elm).closest('.tab-pane').attr('uid');
  
  if ($table.length) {
    window.dt_init[uid] = $table.DataTable({
      serverSide: true,
      processing: false,
      responsive: true,
      ajax: {
        url: dtGetUrl($table),
        data: function (d) {
          d.bc = $(`#${uid}bc`).val();
          d.begin_date = $(`#${uid}begin_date`).val();
          d.end_date = $(`#${uid}end_date`).val();
        },
        type: 'GET',
        beforeSend: function () { dtShowLoading($table); },
        complete: function () {
          dtHideLoading($table);
          //dtRemoveFlexTH('#dt-fixed-assets');
        }
      },
      columns: [
        { data: 'index' },
        { data: 'pabean_code' },
        { data: 'pabean_number' },
        { data: 'pabean_date' },
        { data: 'evidence_number' },
        { data: 'evidence_date' },
        { data: 'entity' },
        { data: 'product_code' },
        { data: 'product_name' },
        { data: 'qty' },
        { data: 'unit' },
        { data: 'value' },

      ],
      columnDefs: [
        {
          targets: -1,
          className: 'text-end'
        },
        {
          targets: 8,
          className: 'text-nowrap'
        }
      ],
      pagingType: 'numbers',
      language: {
        search: ' ',
        lengthMenu: '_MENU_',
        searchPlaceholder: "Search...",
        info: "Showing _START_ to _END_ of _TOTAL_ entries"
      },
      buttons: [],
      pageLength: 10,
      sDom: 'fBtlpi',
      lengthMenu: [[10, 50, 100, 500, 1000, -1], [10, 50, 100, 500, 1000, "All"]]
    });
    dtFinalTouch($table);
  }

  $(document).off('click', `#${uid}btn-filter`)
  $(document).on('click', `#${uid}btn-filter`, function() {
    if($(`#${uid}begin_date`).val() == '') {
      $(`#${uid}begin_date`).focus()
      alert('Tanggal awal harus diisi')
      return
    }

    if($(`#${uid}end_date`).val() == '') {
      $(`#${uid}end_date`).focus()
      alert('Tanggal akhir harus diisi')
      return
    }

    window.dt_init[uid].ajax.reload()
  })

  $(document).off('click', `#${uid}dt-export-ss-excel`)
  $(document).on('click', `#${uid}dt-export-ss-excel`, function() {
    const url = dtGetUrl($table);
    const begin_date = $(`#${uid}begin_date`).val();
    const end_date = $(`#${uid}end_date`).val();
    const bc = $(`#${uid}bc`).val();

    if (begin_date == '') {
      alert('Tanggal awal harus diisi')
      return
    }

    if (end_date == '') {
      alert('Tanggal akhir harus diisi')
      return
    }

    window.open(`${url}.xlsx?begin_date=${begin_date}&end_date=${end_date}&bc=${bc}`)
  })
}
